import { render } from "./AppLoader.vue?vue&type=template&id=5b9e9369"
import script from "./AppLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLoader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Ui/AppLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b9e9369"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b9e9369', __exports__)) {
    api.reload('5b9e9369', __exports__)
  }
  
  module.hot.accept("./AppLoader.vue?vue&type=template&id=5b9e9369", () => {
    api.rerender('5b9e9369', render)
  })

}


export default __exports__